module.exports = __webpack_public_path__ + "img/About-you.c554c77f.svg";